import { useCallback } from "react";
import { makeVar, ReactiveVar, useReactiveVar } from "@apollo/client";
import {
  Maybe,
  Product_Attachments_Insert_Input,
} from "graphql/generated/graphql";

export interface SelectedAttachmentsLocalFieldsType {
  uid: any;
  file: any;
  name?: string;
  size?: string;
  type: string;
  description?: string;
}

const selectedAttachmentsInitialValue: any = {};

type SelectedAttachmentsType = SelectedAttachmentsLocalFieldsType &
  Product_Attachments_Insert_Input;

// The return value of makeVar is a function that you call to read or modify your reactive variable's value.
export const selectedAttachmentsVar: ReactiveVar<SelectedAttachmentsType> =
  makeVar<SelectedAttachmentsType>(selectedAttachmentsInitialValue);

export const clearSelectedAttachments = () => {
  selectedAttachmentsVar(selectedAttachmentsInitialValue);
};

export const useSelectedAttachments = () => {
  const selectedAttachmentsValue = useReactiveVar(selectedAttachmentsVar);

  const updateSelectedAttachments = useCallback(
    (data) => {
      selectedAttachmentsVar({
        ...selectedAttachmentsValue,
        ...data,
      });
    },
    [selectedAttachmentsValue]
  );

  return {
    selectedAttachmentsValue,
    updateSelectedAttachments,
  };
};
